import { db } from '../config/firebase';
import { Firestore, collection, addDoc, query, where, onSnapshot, DocumentData, CollectionReference } from 'firebase/firestore';

/**
 * ADMIN SERVICE (WADE EXECUTIVE ONLY)
 * This service is strictly restricted to Justin's UID: nXhcxEbdy7USg9tBkCiuR1KLynu2
 */

const JUSTIN_UID = "nXhcxEbdy7USg9tBkCiuR1KLynu2";

export const verifyAdminAccess = (uid: string) => {
  return uid === JUSTIN_UID;
};

// 1. Wade's Action Log - Real-time feed of Wade's background work
export const subscribeToWadeActions = (callback: (actions: any[]) => void) => {
  if (!db) return () => {};
  const q = query(collection(db as Firestore, 'executive_data'), where('type', '==', 'action_log'));
  return onSnapshot(q, (snapshot) => {
    const actions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    callback(actions);
  });
};

// 2. Big Bet Scout - Add potential wealth moves to the board
export const logBigBet = async (bet: { title: string, category: 'forex' | 'real_estate' | 'options', detail: string }) => {
  if (!db) throw new Error("Firestore not initialized");
  return await addDoc(collection(db as Firestore, 'wealth_tracking') as CollectionReference<DocumentData, DocumentData>, {
    ...bet,
    timestamp: new Date(),
    status: 'backlog', // Initially dropped into Kanban backlog
    isJustinApproved: false
  });
};

// 3. Voice Triage Engine
export const triageVoiceInput = async (transcript: string) => {
  // Logic to be handled by Wade (the agent) to categorize and drop into board
  console.log("Wade triaging voice input:", transcript);
  // This will be triggered by the mobile Voice Assistant component
};
